module.exports = __webpack_public_path__ + "static/tiny_servant-99b7ba7fdbb7e958cd390deb980bd4a5.jpg";